
export const ACTIVE_LINK = 'activeLink'
export const ACCEPT_QUOTE = 'acceptQuote'
export const ADD_CONTRACTOR = 'addContractor'
export const AGREE_CONTRACTOR_TOE = 'agreeContractorTOE'
export const NEW_CLIENT = 'newClient'
export const CLEAR_MODALS = 'clearModals'
export const CLOSE_MODAL = 'closeModal'
export const CLOSE_MODAL_FORM = 'closeModalForm'
export const CLOSE_FORM = 'closeForm'
export const CLOSE_REPORT = 'closeReport'
export const CURRENT_REPORT_SEARCH = 'currentReportSearch'
export const LOAD_DATA = 'loadData'
export const EDIT_DATABASE_OBJECT = 'editDatabaseObject'
export const NEW_DATABASE_OBJECT = 'newDatabaseObject'
export const DELETE_DATABASE_OBJECT = 'deleteDatabaseObject'
export const REINSTATE_DATABASE_OBJECT = 'reinstateDatabaseObject'
export const DELETE_COMPANY = 'deleteCompany'
export const GET_IN_USE_REPORTS = 'getInUseReports'
export const IN_USE_REPORTS = 'inUseReports'
export const LOAD_DATABASE_MANAGER_LIST = 'loadDatabaseManagerList'
export const DELETE_QUOTE = 'deleteQuote'
export const DISPLAY_SIDEBAR = 'displaySidebar'
export const EDIT_COMPANY = 'editCompany'
export const EXPIRED_SESSION = 'expiredSession'
export const GET_FORM_VALUE = 'getFormValue'
export const GET_FORM_FIELD = 'getFormField'
export const LOAD_CARDS = 'loadCards'
export const LOAD_COMPANY = 'loadCompany'
export const LOAD_DASHBOARD = 'loadDashboard'
export const LOAD_FORM = 'loadForm'
export const LOAD_REPORTS = 'loadReports'
export const LOAD_SETTINGS = 'loadSettings'
export const LOAD_SIDEBAR = 'loadSidebar'
export const LOAD_QUOTE = 'loadQuote'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const MODIFY_FORM_FIELD = 'modifyFormField'
export const MODIFY_FORM_VALUE = 'modifyFormValue'
export const OPEN_CONFIRMATION_MODAL = 'openConfirmationModal'
export const OPEN_ERROR_MODAL = 'openErrorModal'
export const OPEN_MODAL = 'openModal'
export const PBG_REQUEST = 'pBGRequest'
export const SEND_QUOTE = 'sendQuote'
export const SEND_PBG_QUOTE = 'sendPBGrQuote'
export const SEND_REPORT = 'sendReport'
export const REJECT_AND_CREATE_QUOTE = 'rejectAndCreateQuote'
export const SUBMIT_FORM = 'submitForm'
export const TOGGLE_SIDEBAR = 'toggleSidebar'
export const REVIEW_CUSTOMER = 'reviewCustomer'
export const ASSURE_QUALITY = 'assureQuality'
export const ASSIGN_QUOTE = 'assignQuote'
export const COMPLETE_REPORT = 'completeReport'
export const LOAD_STATS = 'loadStats'
export const LOAD_PENDING_CLIENT_COUNT = 'loadPendingClientCount'
export const LOAD_PENDING_APPROVED_QUOTES_COUNT = 'loadPendingApprovedQuotesCount'
export const LOAD_PENDING_MANUAL_QUOTES_COUNT = 'loadPendingManualQuotesCount'
export const LOAD_PENDING_PBG_COUNT = 'loadPendingPBGCount'
export const PRICE_LIST_IMPORT = 'priceListImport'



// WEBPACK FOOTER //
// ./src/vuex/types.js